module.exports = __webpack_public_path__ + "img/bi.91d9c68a.svg";